<template>
  <div
    class="manageshipmentheader"
    :class="
      detail && detail.freightMode === 'AIR'
        ? 'global__bc_purple'
        : detail && detail.freightMode === 'OCEAN'
        ? 'global__bc_blue'
        : detail && detail.freightMode === 'LAND'
        ? 'global__bc_deepgreen'
        : 'global__bc_darkgray'
    "
  >
    <div class="row py-2" v-if="isLoading">
      <half-circle-spinner
        :animation-duration="750"
        :size="100"
        color="#ffff"
        class="mx-auto"
      />
    </div>
    <div class="row m-0" v-else-if="detail">
      <div class="row m-0 w-100">
        <div class="col-md-3 manageshipmentheader__block1">
          <div @click="$router.go(-1)" class="back__button">
            <img src="@/assets/image/icon/arrow-back-full-yellow.svg" alt="" />
            <span class="pl-2">Back</span>
          </div>
          <p>{{ getDateFormat1(detail.createdAt) }}</p>
          <h5>{{ getShipmentFrom(detail.statusShipment) }}</h5>
          <p v-if="detail.freightMode !== 'LAND'">
            {{ getServiceType(detail.shipment_service) }}
          </p>
        </div>
        <div class="col-md manageshipmentheader__block2">
          <h5>{{ getFreightMode(detail.freightMode) }}</h5>
          <p v-if="detail.freightMode !== 'LAND'">
            {{ getShipmentType(detail.freightType.replace(/SEA/g, '')) }}
          </p>
          <p class="pt-2">Route :</p>
          <h6>
            {{ detail.originCity }} [{{ detail.originCountryCode }}] to
            {{ detail.destinationCity }} [{{ detail.destinationCountryCode }}]
          </h6>
        </div>
        <div class="col-md manageshipmentheader__block3">
          <p>Order Number</p>
          <h6>{{ detail.orderNumber }}</h6>
          <p class="pt-2">
            {{
              detail.statusShipment === 1
                ? 'RFQ Number'
                : detail.statusShipment === 2
                ? 'Contract Number'
                : 'Instant Quote Number'
            }}
          </p>
          <h6>{{ detail.referenceNumber }}</h6>
          <div v-if="detail.freights[0].trackingNumber">
            <p>Container Number :</p>
            <h6>{{ detail.freights[0].trackingNumber }}</h6>
          </div>
        </div>
        <div
          class="manageshipmentheader__block4"
          v-if="profile.status === 'ANDALINVERIFICATION'"
        >
          <button
            class="border border-white"
            :class="
              detail.freightMode === 'AIR'
                ? 'button__purplecorporite'
                : detail.freightMode === 'LAND'
                ? 'button__deepgreen'
                : 'button__bluecorporite'
            "
            @click="showPriceDetail(detail.statusShipment, detail)"
          >
            Price Details
          </button>
          <button
            v-if="detail.fiataStatus && detail.fiataStatus.length > 0"
            class="border border-white button__bluecorporite mt-3"
            @click="openModalDownloadFbl()"
          >
            Download FBL
          </button>
        </div>
      </div>
      <DownloadFbl
        :fiataStatus="detail.fiataStatus"
        :orderNumber="detail.orderNumber"
      />
    </div>
    <div v-else class="fontstyle__infotext--white text-center">
      Sorry, something wrong please
      <span class="fontstyle__link--white" @click.prevent="reloadWindow()"
        >try again</span
      >
    </div>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinDateTime from '@/mixin/getters/date-time'
import DownloadFbl from '../../global/modals/DownloadFbl.vue'

export default {
  name: 'HeaderBox',
  mixins: [mixinShipmentDetails, mixinDateTime],
  components: {
    HalfCircleSpinner,
    DownloadFbl
  },
  data() {
    return {
      shipmentId: '',
      orderNumber: ''
    }
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',

      profile: 'auth/profile'
    })
  },
  methods: {
    reloadWindow() {
      // ntar ke mixin global
      window.location.reload()
    },
    async showPriceDetail(statusShipment) {
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber.split('/').join('-')
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_PRICE', {
        shipmentId,
        orderNumber
      })
      const remarks =
        this.detail.bid.length > 0
          ? (this.remarks = this.detail.bid[0].note)
          : ''
      this.$eventHub.$emit('dialog-pricedetails-shipment', {
        typeShipment: this.detail.statusShipment,
        remarks,
        statusShipment,
        shipmentId,
        orderNumber
      })
    },
    openModalDownloadFbl() {
      this.$bvModal.show('modalDownloadFbl')
    }
  },
  watch: {
    detail(data) {
      if (data) {
        this.orderNumber = data.orderNumber
        this.shipmentId = data.shipmentId
        this.$emit('containerNumber', data.freights[0].trackingNumber)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/HeaderBox.vue